/**
 * Experiment observability event constants.
 * 
 * These events are tracked for experiment debugging and monitoring.
 */

/**
 * Experiment execution context (SSR or Client)
 */
export enum ExperimentContext {
  SSR = 'SSR',
  CLIENT = 'Client'
}

/**
 * Experiment decision reasons
 */
export const ExperimentReason = {
  // Layer 1 reasons
  BLOCKED_BY_TENANT_CONFIG: 'Blocked by tenant config (not in features.Experiments)',
  
  // Layer 2 reasons
  BLOCKED_BY_PAYLOAD_CONDITION: 'GrowthBook payload has explicit tenant exclusion',
  
  // Layer 3 reasons
  MODHEADER_OVERRIDE: 'ModHeader override applied',
  URL_OVERRIDE_CONTROL: 'URL override: control',
  URL_OVERRIDE_VARIATION: 'URL override: variation',
  GROWTHBOOK_CONTROL: 'GrowthBook evaluation: control bucket',
  GROWTHBOOK_VARIATION: 'GrowthBook evaluation: variation bucket',
  USER_IN_CONTROL: 'User in control bucket',
  USER_IN_VARIATION: 'User in variation bucket',
} as const;

/**
 * Event names for experiment tracking
 */
export const EXPERIMENT_DECISION = 'ExperimentDecision';
export const EXPERIMENT_VIEWED = 'ExperimentViewed';
export const EXPERIMENT_URL_OVERRIDE = 'ExperimentURLOverride';
